"use client";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import Link from "next/link";
import { Fragment } from "react";

export type BlogBreadcrumbEntry = {
  name: string;
  href?: string;
};

export type BlogBreadcrumbsProps = {
  items: BlogBreadcrumbEntry[];
  className?: string;
};

export function BlogBreadcrumbs({ items, className }: BlogBreadcrumbsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={`${item.name}-${index}`}>
            <BreadcrumbItem>
              {index < items.length - 1 && item.href ? (
                <BreadcrumbLink asChild>
                  <Link href={item.href}>{item.name}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.name}</BreadcrumbPage>
              )}
            </BreadcrumbItem>

            {index < items.length - 1 && <BreadcrumbSeparator />}
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

BlogBreadcrumbs.displayName = "BlogBreadcrumbs";
